import { JourneyStatusType } from '@transferz/fe-models';

import { futureDate } from './utils';

export const isJourneyEditable = (journey: any) => {
  const pickUpDate = journey?.journeyExecutionInfo?.pickupDate;
  const pickUpTimeZone = journey?.journeyExecutionInfo?.pickupTimeZone;
  const isBeforePickupTime = futureDate(pickUpDate, pickUpTimeZone, 'hours') >= 24;
  return (isBeforePickupTime
    && (journey.status === JourneyStatusType.Pending || journey.status === JourneyStatusType.Confirmed || journey.status === JourneyStatusType.Planned)
    && journey?.travellerInfo?.allowedToModifyJourney
  );
};
